import { registrationConsent } from '../../legal/registration';
import { appLocalStorage } from '../../utils/storage';
import { oauthAttemptKey as consentKey } from '../../utils/authAttemptStorage';
const attemptLifetime = 15 * 60 * 1000;

// Android can deliver the App Link into a new TWA tab. sessionStorage belongs
// to the old tab; persist only an expiring, state-bound attempt across tabs.
// This never preselects the checkbox or stores a provider credential.
export function rememberOAuthConsent(provider, { verifier, native = false, serverState } = {}) {
  try {
    const bytes = window.crypto.getRandomValues(new Uint8Array(32));
    const generated = (native && provider === 'google' ? 'ios.' : '')
      + Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    const state = serverState || generated;
    if (!(provider === 'google' ? /^(?:ios\.)?[a-f0-9]{64}$/ : /^[a-f0-9]{64}$/).test(state)) return null;
    const attempt = JSON.stringify({ state, registration: registrationConsent(), createdAt: Date.now(), ...(verifier ? { verifier } : {}) });
    appLocalStorage.setItem(consentKey(provider), attempt);
    return appLocalStorage.getItem(consentKey(provider)) === attempt ? state : null;
  } catch {
    return null;
  }
}

export function consumeOAuthAttempt(provider, state) {
  try {
    const key = consentKey(provider);
    const stored = JSON.parse(appLocalStorage.getItem(key));
    if (!stored) return false;
    const age = Date.now() - stored.createdAt;
    if (!Number.isFinite(stored.createdAt) || age < 0 || age >= attemptLifetime) {
      appLocalStorage.removeItem(key);
      return false;
    }
    // A stale callback must not erase a newer attempt from another tab.
    const pattern = provider === 'google' ? /^(?:ios\.)?[a-f0-9]{64}$/ : /^[a-f0-9]{64}$/;
    if (typeof state !== 'string' || !pattern.test(state) || state !== stored.state) return false;
    appLocalStorage.removeItem(key);
    return stored;
  } catch {
    return false;
  }
}

export function consumeOAuthConsent(provider, state) {
  return Boolean(consumeOAuthAttempt(provider, state));
}

export function clearOAuthCallback(keys) {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const query = new URLSearchParams(window.location.search);
  keys.forEach((key) => { hash.delete(key); query.delete(key); });
  const remaining = hash.toString();
  const search = query.toString();
  window.history.replaceState(window.history.state, '',
    window.location.pathname + (search ? `?${search}` : '') + (remaining ? `#${remaining}` : ''));
}

export function redirectToOAuth(address) {
  window.location.assign(address);
}
